import { iconStyle } from "./styles";

export const SKYBLUE_RECTANGLE_TEST_ID = "skyblue-rectangle-icon";

export default function SkyblueRectangleIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={iconStyle}
      data-testid={SKYBLUE_RECTANGLE_TEST_ID}
    >
      <rect width="16" height="16" fill="#E8F1FF" />
    </svg>
  );
}
